module.exports = __webpack_public_path__ + "static/media/undraw_celebration_0jvk.a3d55e96.svg";